@if (record$ | async; as record) {
  <div class="sh-wrap-text">
    @if (profiles$ | async; as profiles) {
      @for (profile of profiles; track profile) {
        <sh-profile-readonly-fieldset [profile]="profile" [record]="record" [aiProfile]="aiProfile"></sh-profile-readonly-fieldset>
      }
      @if (profiles.length === 0) {
        <sh-notification
          [type]="notificationType.Error"
          [title]="'record-detail.notifications.no-profiles.title' | translate"
          [message]="'record-detail.notifications.no-profiles.message' | translate: { amount: 1 }"
          [icon]="'delete'"
        ></sh-notification>
      }
    }
  </div>
}
